<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
       
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="2" class="py-2">
                <span><b>Reports</b></span>
              </b-col>
              <b-col cols="12" md="7" class="py-2">
                
              </b-col>
              

                <b-col cols="12" md="3" class="py-2">
                <b-form @submit.prevent="getSearch">
                  <b-row>
                    <b-col cols="12">
                      <b-form-input
                        
                        v-model="searchKey"
                        placeholder="Search"
                        size="sm"
                      ></b-form-input> 
                      <!-- <datalist id="searchData"> list="searchData"
                        <option v-for="(item,i) in searchData" :key="i">{{item}}</option>
                      </datalist> -->
                    </b-col>
                    <!-- <b-col cols="4">
                      <b-button variant="outline-primary" size="sm" @click="getSearch">Search</b-button>
                    </b-col> -->
                  </b-row>
                </b-form>
              </b-col>
              
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="reports"
            :fields="fields"
            @row-clicked="rowClicked"
          >
          <template v-slot:cell(reportid)="data">
              <span v-if="data.item.reportID">{{data.item.reportID}}</span>
            </template>
            <template v-slot:cell(reportdate)="data">
              <span v-if="data.item.added_date">{{formatDate(data.item.added_date)}}</span>
            </template>
            <template v-slot:cell(crime)="data">
              <span
                v-if="data.item.crimeTypeId"
              >{{data.item.crimeTypeId.cname}}</span>
              <span v-else>-</span>
            </template>
            
            <template v-slot:cell(country)="data">
              <span
                v-if="data.item.country"
              >{{data.item.country}}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:cell(nation)="data">
              <span
                v-if="data.item.nationality"
              >{{data.item.nationality}}</span>
              <span v-else>-</span>
            </template>
            
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalData"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextPage"
            />
          </nav>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      reports: [],
      fields: [
        { key: "reportid", label: "Id", sortable: false },
        { key: "reportdate", label: "Date", sortable: false },
        // { key: "lastname", label: "Suspect Last Name", sortable: false },
        // { key: "firstname", label: "Suspect First Name", sortable: false },
        // { key: "middlename", label: "Suspect Middle Name", sortable: false },
        { key: "crime", label: "Type of crime", sortable: false },
        { key: "country", label: "Country", sortable: false },
        { key: "nation", label: "Nationality", sortable: false },
       
      ],
      totalData: 0,
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      tableType: null,
      searchKey: null,
      searchData: [],
      division: null,
      divisions: [],
      range: null,
      ranges: [],
      isreviewed: null,
      userRole: localStorage.getItem("role"),
      userType:localStorage.getItem("usrType")
    };
  },
  mounted() {
     this.getData();
  },
  watch:{
    searchKey:function(){
      this.getSearch();
    }
  },
  methods: {
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.division = response.data.data.division._id;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    nextPage(ev) {
      this.currentPage = ev;
      this.getData();
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/reports/all/list",
        method: "POST",
        headers: {
          "token": localStorage.getItem("token"),
        },
        data: {
          limit: this.perPage,
          page: this.currentPage,
          
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.reports = response.data.data;
          this.totalData = response.data.totalLength;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
   
      getSearch() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/reports/search",
        headers: {
          "token": localStorage.getItem("token"),
        },
        data: {
          limit: this.perPage,
          page: this.currentPage,
          keyword: this.searchKey,
         
        },
      })
        .then((response) => {
          if(this.searchKey == '' || this.searchKey == null)
          {
          this.appLoading = false;
          
           this.getData();
          }
          else{
            this.appLoading = false;
          this.reports = response.data.data;
          this.totalData = response.data.totalLength;
          }
         
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year;
        // " " +
        // hours +
        // ":" +
        // minutes +
        // " " +
        // ampm;
      return strTime;
    },
    rowClicked(item) {
      this.$router.push("/Reports/" + item._id);
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
